import { useCallback, useReducer, useRef, useState } from "react";
import { ApiConnector } from "common/ApiConnector";

const url_endpoint = "api/v1";

export const useInstancesPublic = (nodeId) => {
    const [info, setInfo] = useState({});
    const [nodeStatus, setNodeStatus] = useState(info.status ?? "STOPPED");

    const getInfo = async () => {
        let res = await ApiConnector.get(`${url_endpoint}/public-instance-info/${nodeId}`);
        setInfo(res.data);
        return res.data;
    }

    const start_node = async () => {
        await ApiConnector.get(`${url_endpoint}/public-instance-start/${nodeId}`);
    }

    const stop_node = async () => {
        await ApiConnector.get(`${url_endpoint}/public-instance-stop/${nodeId}`);
    }

    const starting_node = async () => {
        setNodeStatus("STARTING");

        await start_node();
        console.info("Finalizado.");
    }

    const reset_node = async () => {
        await ApiConnector.get(`${url_endpoint}/public-instance-reset/${nodeId}`);
    }

    const ws = useRef();
    const connectWS = (code) => {
        try {

            if(!ws.current) {
                ws.current = new WebSocket(`wss://was2.myquickone.com/client`);
                ws.current.onopen = () => {
                    console.log('WebSocket connected');
                };

                ws.current.onmessage = (event) => {
                    console.log(`onmessage: ${event.data}`);
                    let data = JSON.parse(event.data);

                    if(data.type === "req_system" && data.command === "send_info") {
                        ws.current.send(JSON.stringify({
                            command: "send_info",
                            response: {
                                type: "client",
                                node_id: code
                            }
                        }));
                    }

                    if(data.type === "info_status") {
                        let {qr, status, auth_status} = data.response;
                        setInfo(prev => ({...prev, qr: qr, status: status, auth_status: auth_status}));
                    }
                };

                ws.current.onclose = () => {
                    console.log('WebSocket disconnected');
                };

                ws.current.onerror = (error) => {
                    console.error('WebSocket error:');
                };
            }

        } catch (error) {
            console.log(error);
        }

    }

    const disconnectWS = () => {
        if(ws.current) {
            ws.current.close();
        }
    }

    return {
        getInfo,
        info,
        node: {
            status: nodeStatus,
            start: starting_node,
            stop: stop_node,
            reset: reset_node
        },
        WSock: {
            connect: connectWS,
            disconnect: disconnectWS,
            socket: ws.current
        }
    };
}
